import { loadWebEnv } from "@pima/runtime-config";

/** The validated runtime-config boundary for the web application. */
export const env = loadWebEnv();

export const processEnvCompatibility = {
  NODE_ENV: import.meta.env.MODE,
  ...Object.fromEntries(
    Object.entries(env).map(([key, value]) => [`NEXT_PUBLIC_${key}`, value]),
  ),
};

// Install compatibility before dependent route modules evaluate.
globalThis.__PIMA_PROCESS_ENV__ = processEnvCompatibility;

// Vite serves process.env reads unchanged in development. Its early define
// injection runs before this map exists, so install the validated values now.
if (import.meta.env.DEV) {
  const devGlobal = globalThis as unknown as {
    process?: { env?: Record<string, string | undefined> };
  };
  devGlobal.process ??= {};
  devGlobal.process.env = {
    ...devGlobal.process.env,
    ...processEnvCompatibility,
  };
}

declare global {
  // Production builds rewrite process.env reads to this validated map.
  var __PIMA_PROCESS_ENV__: typeof processEnvCompatibility;
}
